import React, { useEffect, useState } from "react";
import { apiHelper } from "../../lib/ApiHelper";
import { AgGridReact } from '@ag-grid-community/react';
import {
    ModuleRegistry
} from "@ag-grid-community/core";
import PRHError from "../../lib/PRHError";
import PRHLoader from "../../lib/PRHLoader";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
ModuleRegistry.registerModules([ClientSideRowModelModule, RowGroupingModule]);
import { LicenseManager } from "@ag-grid-enterprise/core";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-balham.css";


LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");

export default function OverView(props) {
    const [InventoryBulkData, setInventoryBulkData] = useState([]);
    const [InventoryPackData, setInventoryPackData] = useState([]);
    const [InventoryDetailData, setInventoryDetailData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [apiError, setApiError] = useState(null);

    const formatNumberWithCommas = (number) => {
        if (!number || isNaN(number)) {
            return '0';
        }
        // Convert number to string
        let str = number.toString();
        if (str.indexOf('.') <= 0) {
            return formatNumberAddCommas(str)
        }
        // Split the number into integer and decimal parts
        let parts = str.split(".");
        return formatNumberAddCommas(parts[0]);
    }

    const formatNumberAddCommas = (strNumber) => {
        try {
            if (strNumber?.length > 3) {
                // Format integer part with commas
                return strNumber?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? strNumber;
            } else {
                return strNumber;
            }
        }
        catch {
            return strNumber;
        }
    }

    const sumAggregator = (values) => {
        let sum = 0;
        values.values.forEach(value => {
            const num = parseFloat(value);
            if (!isNaN(num)) {
                sum += num;
            }
        });
        return sum;
    }

    const gridOptionsBulkDet = {
        columnDefs: [
            {
                headerName: "Bulk Gross", field: "blK_LABST", width: 100, headerClass: "HeaderClassSource header-text-right", cellRenderer: (params) => {
                    return <span>{formatNumberWithCommas(params.value)}</span>;
                }, cellClass:"cell-text-right"
            },
            {
                headerName: "Bulk Net", field: "blK_ATP", width: 100, headerClass: "HeaderClassSource header-text-right", cellRenderer: (params) => {
                    return <span>{formatNumberWithCommas(params.value)}</span>;
                }, cellClass: "cell-text-right"
            }],
        defaultColDef: {
            resizable: true,
        }
    }

    const gridOptionsNetDet = {
        columnDefs: [
            {
                headerName: "Pack Gross", field: "seT_LABST", width: 100, headerClass: "HeaderClassSource header-text-right", cellRenderer: (params) => {
                    return <span>{formatNumberWithCommas(params.value)}</span>;
                }, cellClass: "cell-text-right"
            },
            {
                headerName: "Pack Net", field: "seT_ATP", width: 100, headerClass: "HeaderClassSource header-text-right", cellRenderer: (params) => {
                    return <span>{formatNumberWithCommas(params.value)}</span>;
                }, cellClass: "cell-text-right"
            },
        ],
        defaultColDef: {
            resizable: true,
        },
    }

    const gridOptionsInventoryDet = {
        columnDefs: [{
            headerName: "Sloc", field: "lgort", width: 100, headerClass: "HeaderClassSource", rowGroup: true, hide: true
        },
        {
            headerName: "Batch", field: "charg", width: 80, headerClass: "HeaderClassSource", cellClass:"cell-text-left"
        },
        {
            headerName: "Unrestricted", field: "clabs", width: 80, headerClass: "HeaderClassSource header-text-right", valueGetter: 'data.clabs', aggFunc: sumAggregator, cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "cell-text-right"
        },
        {
            headerName: "Deliveries", field: "dlvrs", width: 80, headerClass: "HeaderClassSource header-text-right", valueGetter: 'data.dlvrs', aggFunc: sumAggregator, cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
                }, cellClass: "cell-text-right"
        },
        {
            headerName: "Sales Orders", field: "ordrs", width: 80, headerClass: "HeaderClassSource header-text-right",  valueGetter: 'data.ordrs', aggFunc: sumAggregator, cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "cell-text-right"
        },
        {
            headerName: "Net Inventory", field: "ntinv", width: 80, headerClass: "HeaderClassSource header-text-right", valueGetter: 'data.ntinv', aggFunc: sumAggregator, cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "cell-text-right"
        },
        {
            headerName: "WIP", field: "activeBatch", headerClass: "HeaderClassSource header-text-right", width: 80, cellClass: "cell-text-right"
        },
        {
            headerName: "Quotes", field: "quote", width: 80, headerClass: "HeaderClassSource header-text-right",  valueGetter: 'data.quote', aggFunc: sumAggregator, cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "cell-text-right"
        },
        {
            headerName: "X Memos", field: "xmemo", width: 80, headerClass: "HeaderClassSource header-text-right",  valueGetter: 'data.xmemo', aggFunc: sumAggregator, cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "cell-text-right"
        },
        {
            headerName: "QI", field: "cinsm", width: 80, headerClass: "HeaderClassSource header-text-right",  valueGetter: 'data.cinsm', aggFunc: sumAggregator, cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "cell-text-right"
        }
        ],
        defaultColDef: {
            resizable: true,
            sortable: true,
            enableRowGroup: true,
        },
        autoGroupColumnDef: {
            minWidth: 300,
            headerClass: "HeaderClassSource"
        },
        grandTotalRow: "bottom",
        rowGroupPanelShow: 'always',
    };


    const getOverviewDetails = async () => {
        try {
            setIsLoading(true); setApiError(null);
            setInventoryBulkData([]);
            setInventoryPackData([]);
            setInventoryDetailData([]);
            const data = await apiHelper.inventoryUserPostCall("getauthorizetoken");
            if (data.errorCode == null) {
                var token = data.accessToken;
                const data1 = await apiHelper.inventoryUserPostCall("getoverview", {
                    Token: token,
                    overviewInput: {
                        P_BATCH: "X",
                        P_DETAIL: "X",
                        P_MATNR: props.ISBNId
                    }
                });
                if (data1) {
                    if (data1.p_ZBAPI_INVENTORY_DETAIL)
                        setInventoryDetailData(data1.p_ZBAPI_INVENTORY_DETAIL.item);
                    else
                        setInventoryDetailData([]);
                    if (data1.p_ZBAPI_INVENTORY_ON_HAND) {
                        setInventoryBulkData(data1.p_ZBAPI_INVENTORY_ON_HAND.item);
                        setInventoryPackData(data1.p_ZBAPI_INVENTORY_ON_HAND.item);
                    }
                    else {
                        setInventoryBulkData([]);
                        setInventoryPackData([]);
                    }
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getOverviewDetails();
    }, [props.metaData]);

    return (<>

        <div className="custom" style={{ paddingLeft: "10px", marginBottom: "15px" }}>
            <div className="ag-theme-balham" style={{ paddingLeft: "10px", marginBottom: "10px" }}>
                {isLoading && <PRHLoader />}
                {apiError && <PRHError error={apiError} />}
                <AgGridReact
                    rowData={InventoryDetailData}
                    domLayout="autoHeight"
                    gridOptions={gridOptionsInventoryDet}
                    groupDefaultExpanded={1}
                    suppressAggFuncInHeader={true}
                />
            </div>
            <p className="ml-0 mb-0 padding-top-10"></p>
            <div className="ag-theme-balham" style={{ paddingLeft: "10px", marginBottom: "10px", display: "inline-block", width: "30%" }}>
                <AgGridReact
                    rowData={InventoryBulkData}
                    domLayout="autoHeight"
                    gridOptions={gridOptionsBulkDet}
                />
            </div>
            <div className="ag-theme-balham" style={{ paddingLeft: "30px", marginBottom: "10px", display: "inline-block", width: "30%" }}>
                <AgGridReact
                    rowData={InventoryPackData}
                    domLayout="autoHeight"
                    gridOptions={gridOptionsNetDet}
                />
            </div>
        </div>
    </>)
}
